const $$splitComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(app)/org/$org/settings/open-positions/route.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute, redirect } from '@tanstack/react-router';
import { requirePermission } from '@/lib/hooks/common/usePermissions';
import i18n from '@/lib/translations/i18n';
import { ensureNamespaceLoaded } from '@/lib/translations/i18nloader';
export const Route = createFileRoute('/(app)/org/$org/settings/open-positions')({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  beforeLoad: async ctx => {
    await requirePermission('edit_capacity')(ctx);
    await ensureNamespaceLoaded('teams');
    if (!ctx.context.flags.capacityOpenPositions) {
      throw redirect({
        to: '/org/$org/settings',
        params: {
          org: ctx.params.org
        }
      });
    }
  },
  loader: (): LoaderData => ({
    crumb: i18n.t($ => $.common.openPositions)
  })
});